export default __webpack_public_path__ + "static/media/gallery-wip-neck_04.940a1ea8.jpg";